import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { COMPLETE_STEP } from "basic-details/basicDetailsActions";
import {
  SET_ACTIVE_STEP,
  SHOW_CANCEL_SUBMISSION_DIALOG,
} from "submission/submissionActions";

import {
  getSubmitterIsCreator,
  isPersonalInfoStepLoading,
} from "common/selectors";

import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import LoadingPanel from "general-components/LoadingPanel";
import StepPanelButtonBar from "general-components/StepPanelButtonBar";
import PersonalDetailsForm from "basic-details/components/PersonalDetailsForm";
import CreatorDetailsForm from "basic-details/components/CreatorDetailsForm";

import * as steps from "common/steps";
import {
  FIELD_BLURRED,
  COUNTRY_CHANGED,
  LOCAL_LIBRARY_CHANGED,
  REGION_CHANGED,
  ROLE_CHANGED,
  FIELD_CHANGED,
  SET_SHOW_LOCAL_LIBRARY_OTHER,
} from "basic-details/basicDetailsActions";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 2,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  section: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },

  sectionHeader: {
    marginBottom: theme.spacing(2),
  },

  heading: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.dark,
  },

  subheading: {
    fontSize: ".85rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
}));

const BasicDetails = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const loading = useSelector(isPersonalInfoStepLoading);
  const isSubmitterCreator = useSelector(getSubmitterIsCreator);

  const dispatch = useDispatch();
  const onPrevious = () =>
    dispatch({ type: SET_ACTIVE_STEP, step: steps.INTRO });
  const onNext = () => dispatch({ type: COMPLETE_STEP });
  const onCancel = () =>
    dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: true });

  const actions = {
    FIELD_BLURRED,
    COUNTRY_CHANGED,
    LOCAL_LIBRARY_CHANGED,
    REGION_CHANGED,
    ROLE_CHANGED,
    FIELD_CHANGED,
    SET_SHOW_LOCAL_LIBRARY_OTHER,
  };

  return loading ? (
    <LoadingPanel />
  ) : (
    <Paper classes={{ root: classes.root }} elevation={0}>
      {isSubmitterCreator ? (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <div className={classes.heading}>{t("basic_about_you")}</div>
            <div className={classes.subheading}>{t("basic_details_you")}</div>
          </div>
          <PersonalDetailsForm actions={actions} />
        </div>
      ) : (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <div className={classes.heading}>{t("basic_about_creator")}</div>
            <div className={classes.subheading}>
              {t("basic_details_creator")}
            </div>
          </div>
          <CreatorDetailsForm />
        </div>
      )}
      <div>
        <StepPanelButtonBar
          onNext={onNext}
          onPrevious={onPrevious}
          onCancel={onCancel}
        />
      </div>
    </Paper>
  );
};

export default BasicDetails;
